import { appConfig } from "@/guards/auth/azure-b2c.config";

export * from "./paths";
export const FALLBACK_SESSION_TIMEOUT = 60 * 60 * 1000; // 60 minutes
export const SESSION_TIMEOUT = Number(
  appConfig && appConfig.SESSION_TIMEOUT
    ? appConfig.SESSION_TIMEOUT
    : FALLBACK_SESSION_TIMEOUT,
);

export const TOAST_DEFAULT_DURATION = 5000;

export const COUNT_LIMIT = 99;
export const INPUT_DELAY = 300;

export const CONTENT_ITEM_TO_LOAD = 30;

export const SUPPORT_EMAIL = "support@abc.ae";

export const DEFAULT_DATE_FORMAT = "dd/MM/yyyy";
export const DEFAULT_TIME_FORMAT = "hh:mm a";
export const NEWS_DATE_FORMAT = "dd MMM yyyy";

export const CONTRACTORS_LICENCE_DATE_FORMAT = "MM/dd/yyyy";

export const DATE_FORMAT_WITH_TIMEZONE = "yyyy-MM-dd'T'HH:mm:ss.SSSxxx";

export enum AcceptedDocFormatsType {
  Pdf = "pdf",
  Jpg = "jpg",
  Jpeg = "jpeg",
}

export enum AcceptedFileFormatsType {
  Pdf = "application/pdf",
  Jpg = "image/jpg",
  Jpeg = "image/jpeg",
}

export const ACCEPTED_FILE_FORMATS = [
  AcceptedFileFormatsType.Pdf,
  AcceptedFileFormatsType.Jpg,
  AcceptedFileFormatsType.Jpeg,
];

export const MAX_JPG_SIZE = 1000000;
export const MAX_PDF_SIZE = 10000000;

export const fileTypeMaxSizeMap: Record<AcceptedFileFormatsType, number> = {
  [AcceptedFileFormatsType.Pdf]: MAX_PDF_SIZE,
  [AcceptedFileFormatsType.Jpg]: MAX_JPG_SIZE,
  [AcceptedFileFormatsType.Jpeg]: MAX_JPG_SIZE,
};

export const NO_VALUE = "-";

export enum LocalStorageKey {
  Theme = "theme",
  SessionKey = "lastSessionTimeStamp",
}

export enum ThemeType {
  Light = "light",
  Dark = "dark",
}

export enum RequestStatus {
  Progress = "In Progress",
  Approved = "Approved",
  Rejected = "Rejected",
  Cancelled = "Cancelled",
  Returned = "Returned",
  Draft = "Draft",
}

export const DEFAULT_DROPDOWN_NONE_VALUE = {
  Id: 0,
  Value: "None",
  CompanyNameEn: "None",
};

export enum DocTypeIds {
  Contractor = 46,
  Subcontractor = 2400,
  PersonList = 41,
  VesselList = 45,
  PhotographyPermitsList = 44,
  VehiclesList = 42,
}

export const DEFAULT_REQUEST_START_STEP = 0;
export const DEFAULT_REQUEST_START_SUB_STEP = "a";
export const SECONDARY_REQUEST_START_SUB_STEP = "b";

export const PERSONNELS_SOURCE_URL =
  "https://www.fieldglass.ae/SSOLogin?TARGET=company%3D1ADN";

export const DEFAULT_LOADING_TEXT = "Loading...";

export const DEFAULT_SELECT_PLACEHOLDER_TEXT = "Select";

export const CICPA_TOAST_ID = "cicpaToastId";

export const COMPANY_NAME_AR_TOAST_ID = "companyNameToastId";
